import { useState } from "react"
import useSWR from "swr"
import { Table } from "antd"
import { Column, Row } from "react-display-flex"

import { fetcher } from "../../api"
import { KycCustomer } from "./models"
import { buildKycCustomersTableColumns } from "./kyc-customers-table-columns"
import { UpdateKycCustomerDrawer } from "./UpdateKycCustomer/UpdateKycCustomerDrawer"
import { SelectIssuer, SelectTenant } from "../../components"
import "./kyc-customers.scss"

export const KycCustomers = () => {
  const [updatingCustomer, setUpdatingCustomer] = useState(null)
  const [currentTenant, setCurrentTenant] = useState('')
  const [currentIssuer, setCurrentIssuer] = useState('')
  
  const params = new URLSearchParams({ tenantId: currentTenant, issuerId: currentIssuer })
  const { data: customers, mutate } = useSWR<KycCustomer[]>(`/kyc?${params.toString()}`, fetcher)

  const onCustomerUpdateClick = (customer: KycCustomer) => {
    setUpdatingCustomer(customer)
  }

  const onUpdateClose = () => {
    setUpdatingCustomer(null)
  }

  const onUpdateSuccess = () => {
    mutate()
    onUpdateClose()
  }

  return (
    <Column className="kyc-customers">
      <Row className="kyc-customers-filters">
        <SelectIssuer
          onIssuerSelected={(issuerId) => setCurrentIssuer(issuerId?.toString() || '')}
        />
        <SelectTenant
          onTenantSelected={(tenantId) => setCurrentTenant(tenantId?.toString() || '')}
          tenantKey="id"
          allowClear
        />
      </Row>
      <Table
        columns={buildKycCustomersTableColumns({ onUpdate: onCustomerUpdateClick })}
        dataSource={customers}
        loading={!customers}
        rowKey="id"
        pagination={false}
        size="small"
      />
      <UpdateKycCustomerDrawer
        customer={updatingCustomer}
        isVisible={!!updatingCustomer}
        onClose={onUpdateClose}
        onSuccess={onUpdateSuccess}
      />
    </Column>
  )
}